import { TemplateCardDataType } from '../../modules/home/v1/typings/message-types';
import { TemplateData } from '../../modules/template-list/typings';

export enum TemplateCategory {
  ACCOUNT_UPDATE = 'ACCOUNT_UPDATE',
  PAYMENT_UPDATE = 'PAYMENT_UPDATE',
  PERSONAL_FINANCE_UPDATE = 'PERSONAL_FINANCE_UPDATE',
  SHIPPING_UPDATE = 'SHIPPING_UPDATE',
  RESERVATION_UPDATE = 'RESERVATION_UPDATE',
  ISSUE_RESOLUTION = 'ISSUE_RESOLUTION',
  APPOINTMENT_UPDATE = 'APPOINTMENT_UPDATE',
  TRANSPORTATION_UPDATE = 'TRANSPORTATION_UPDATE',
  TICKET_UPDATE = 'TICKET_UPDATE',
  ALERT_UPDATE = 'ALERT_UPDATE',
  AUTO_REPLY = 'AUTO_REPLY',
  TRANSACTIONAL = 'TRANSACTIONAL',
  MARKETING = 'MARKETING',
  OTP = 'OTP',
  AUTHENTICATION = 'AUTHENTICATION',
}

export enum TemplateReducerActionTypes {
  STATUS = 'status',
}

export interface TemplateAtom {
  [TemplateReducerActionTypes.STATUS]: TemplateStatus;
}

export enum TemplateStatus {
  ALL = 'ALL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  PAUSED = 'PAUSED',
  PENDING_DELETION = 'PENDING_DELETION',
  FAILED = 'FAILED',
  NEEDS_CLARIFICATION = 'NEEDS_CLARIFICATION',
  IN_APPEAL = 'IN_APPEAL',
  OTHERS = 'OTHERS',
}

export interface TemplateStatusOption {
  name: string;
  value: TemplateStatus;
  bgColor: string;
  textColor: string;
  dotColor?: string;
}

export const TemplateStatusOptions: TemplateStatusOption[] = [
  {
    name: 'All',
    value: TemplateStatus.ALL,
    bgColor: '#F3F3F4',
    textColor: '#2D2D2D',
  },
  {
    name: 'Approved',
    value: TemplateStatus.APPROVED,
    bgColor: '#007A2514',
    textColor: '#3F906D',
  },
  {
    name: 'Pending',
    value: TemplateStatus.PENDING,
    bgColor: 'rgba(214, 153, 0, 0.08)',
    textColor: '#D69900',
  },
  {
    name: 'Rejected',
    value: TemplateStatus.REJECTED,
    bgColor: 'rgba(194, 19, 19, 0.08)',
    textColor: '#C21313',
  },
  {
    name: 'Needs Clarification',
    value: TemplateStatus.NEEDS_CLARIFICATION,
    bgColor: 'rgba(88, 88, 88, 0.10)',
    textColor: '#585858',
  },
];

export enum TemplateType {
  ALL = 'ALL',
  PREDEFINED = 'PREDEFINED',
  CUSTOM = 'CUSTOM',
}

export interface SampleValuesFamilyType {
  id: string;
  name: string;
  sampleValue: SampleValue;
}
export interface SampleValue {
  sample: string[];
  totalCustomerCount: number;
  customerWithGivenFieldCount: number;
}

interface StatusAction {
  type: TemplateReducerActionTypes.STATUS;
  data: TemplateStatus;
}

export type TemplateReducerAction = StatusAction;

export enum TemplateButtonType {
  QUICK_REPLY = 'QUICK_REPLY',
  URL = 'URL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  FLOW = 'FLOW',
  OTP = 'OTP',
}

export enum TemplateComponentFormat {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
  VIDEO = 'VIDEO',
  LOCATION = 'LOCATION',
}

export enum TemplateComponentTypes {
  HEADER = 'HEADER',
  BODY = 'BODY',
  FOOTER = 'FOOTER',
  BUTTON = 'BUTTON',
  CARD = 'CARD',
  CAROUSEL = 'CAROUSEL',
  CALL_PERMISSION_REQUEST = 'CALL_PERMISSION_REQUEST',
}

export type VariablesType = 'header' | 'body' | 'button' | 'card';

export type CardVariablesFormat = {
  cardIndex: number;
  components: Array<{
    type: TemplateComponentTypes;
    parameters: Array<Record<string, string | File>>;
  }>;
};

export interface TemplateOTPButton {
  type: TemplateButtonType.OTP;
  otpType: 'COPY_CODE';
  otp: string;
  text: string;
}

export interface TemplateURLButton {
  type: TemplateButtonType.URL;
  url: string;
  example?: string;
  text: string;
  urlTagExample?: string;
  urlTagExampleId?: string;
  wrapUrl?: boolean;
  urlType?: string;
}

export interface TemplatePhoneButton {
  type: TemplateButtonType.PHONE_NUMBER;
  phoneNumber: string;
  text: string;
}

export interface TemplateReplyButton {
  type: TemplateButtonType.QUICK_REPLY;
  text: string;
}

export interface TemplateFlowButton {
  type: TemplateButtonType.FLOW;
  text: string;
  flowId: string;
}

export type TemplateButtonTypes =
  | TemplateURLButton
  | TemplatePhoneButton
  | TemplateReplyButton
  | TemplateFlowButton
  | TemplateOTPButton;

export interface TemplateButtonComponent {
  type: TemplateComponentTypes.BUTTON;
  buttons: Array<TemplateButtonTypes>;
}
export type TemplateCardWithComp = {
  components?: Array<TemplateData | CardTemplateComponentItemProps>;
}[];
export interface TemplateCardsComponent {
  type: TemplateComponentTypes.CARD | TemplateComponentTypes.CAROUSEL;
  cards: TemplateCardDataType[]; //| TemplateCardWithComp;
}
export interface TemplateTextHeaderComponent {
  format: TemplateComponentFormat.TEXT;
  text: string;
  example?: Record<string, string>;
}

export interface TemplateMediaHeaderComponent {
  format: TemplateComponentFormat.IMAGE | TemplateComponentFormat.VIDEO | TemplateComponentFormat.DOCUMENT;
  example: {
    link: string;
    previewlink?: string | File;
    thumbnailUrl?: string;
  };
  link?: string;
  fileName?: string;
  thumbnailUrl?: string;
}

export type TemplateHeaderComponent = {
  type: TemplateComponentTypes.HEADER;
} & (TemplateTextHeaderComponent | TemplateMediaHeaderComponent);

export interface TemplateBodyComponent {
  type: TemplateComponentTypes.BODY;
  text: string;
  add_security_recommendation?: boolean;
  example?: Record<string, string>;
}

export interface TemplateCallConsentComponent {
  type: TemplateComponentTypes.CALL_PERMISSION_REQUEST;
}

export interface TemplateCallConsentComponent {
  type: TemplateComponentTypes.CALL_PERMISSION_REQUEST;
}

export type CardTemplateComponentItemProps = TemplateHeaderComponent | TemplateBodyComponent | TemplateButtonComponent;

export interface TemplateFooterComponent {
  type: TemplateComponentTypes.FOOTER;
  text: string;
  code_expiration_minutes?: number;
}

export type TemplateComponent =
  | TemplateHeaderComponent
  | TemplateBodyComponent
  | TemplateFooterComponent
  | TemplateButtonComponent
  | TemplateCardsComponent
  | TemplateCallConsentComponent;

export type TemplateComponentsArray = Array<TemplateComponent>;

export interface Template {
  id: number;
  remoteId: string;
  name: string;
  components: TemplateComponentsArray;
  language: string;
  status: TemplateStatus;
  category: TemplateCategory;
  type: TemplateType;
  rejectedReason?: string;
  dateCreated: number;
  dateUpdated: number;
  integrationId: string;
  dateDeleted: number | null;
  createdBy: string;
  createdByUser: {
    id: string;
    name: string;
  };
  editDetails: {
    editable: boolean;
    bots: Array<{
      botId: string;
      botName: string;
      botStatus: 'ACTIVE' | 'INACTIVE';
    }>;
    groups: Array<{
      groupName: string;
      groupId: string;
      chatMessageId: string;
    }>;
    chats: Array<{
      customerName: string;
      chatMessageId: string;
    }>;
    reason?: string;
  };
}

export interface TemplateV2 {
  id: number;
  remoteId: string;
  name: string;
  components: TemplateComponentsArray;
  language: string;
  status: TemplateStatus;
  category: TemplateCategory;
  allCategories: TemplateCategory[];
  type: TemplateType;
  rejectedReason?: string;
  dateCreated: number;
  dateUpdated: number;
  lastUsedAt: string | null;
  integrationId: string;
  dateDeleted: number | null;
  createdBy: string;
  languageName: string;
  agentCount: number;
  createdByUser: {
    id: string;
    name: string;
  };
  approvedCount: string;
  rejectedCount: string;
  pendingCount: string;
  waApiNumber: string;
  otherCount: string;
  wabaName: string;
  wabaCount: string;
  highQualityCount: string;
  mediumQualityCount: string;
  lowQualityCount: string;
  integrationIds: string[];
}

export interface TempaltePaginationData {
  limit: number;
  offset: number;
}

export interface QuickReply {
  id: string;
  shortcut: string;
  message: string;
}

export interface UserCustomTextType {
  nameKey: string;
  value: string;
}

export interface TemplateMessageErrorType {
  totalCount: number;
  erroredCount: number;
  flaggedCustomFields: string[];
  flaggedCustomFieldTexts: UserCustomTextType[];
}
export interface GetRedirectParamsApiResponse {
  wabaNumber: string;
  customerNumber: string;
}
